<template>
  <div></div>
</template>

<script>
export default {
  name: 'BackMovieManage'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pc/pages/back/movie/BackMovieManage.vue